import React from 'react';

const dataContext = React.createContext({});

export default dataContext